<template>
  <div class="version-container">
    <h1>Versioning</h1>
    <div class="version-info">
      <p>Version: {{ version }}</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'versionPage',
  setup() {
    const version = ref('')

    onMounted(async () => {
      try {
        const response = await fetch('/version')
        version.value = await response.text()
      } catch (error) {
        console.error('Error fetching status:', error)
        version.value = 'Error loading status'
      }
    })

    return {
      version
    }
  }
}
</script>

<style scoped>
.version-container {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.version-info {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #000000;
  border-radius: 4px;
}
</style> 